var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-rating',{attrs:{"color":"warning","background-color":"warning","half-increments":"","hover":""},model:{value:(_vm.rating),callback:function ($$v) {_vm.rating=$$v},expression:"rating"}})}
var staticRenderFns = []

export { render, staticRenderFns }